export default "__VITE_ASSET__DJGHiGrq__"